module.exports = __webpack_public_path__ + "static/media/blob.66f8f9b0.svg";